import React from "react";

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/assets/vision_logo.jpeg" alt="Vision Logo" />
              <h3>Vision</h3>
            </div>
            <div className="organization-info">
              <p>
                Vision एक स्वैच्छिक समुदायिक समूह है जो कटनी, मध्य प्रदेश में
                शहर की सफाई और पर्यावरण संरक्षण के क्षेत्र में काम कर रहा है।
              </p>
            </div>
          </div>

          <div className="footer-section">
            <h4>📞 संपर्क जानकारी</h4>
            <div className="contact-list">
              <div className="contact-item">
                <strong>📍 स्थान:</strong>
                <p>कटनी, मध्य प्रदेश</p>
              </div>
              <div className="contact-item">
                <strong>🗺️ सेवा क्षेत्र:</strong>
                <p>संपूर्ण कटनी जिला</p>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>🚀 हमारे कार्य</h4>
            <ul className="service-list">
              <li>🌳 वृक्षारोपण और संरक्षण</li>
              <li>🏞️ तालाब और जल निकाय सफाई</li>
              <li>🏺 जल संरक्षण और वितरण</li>
              <li>🎨 दीवार चित्रकारी और जागरूकता</li>
              <li>♻️ अपशिष्ट प्रबंधन और पुनर्चक्रण</li>
              <li>🌍 पर्यावरण शिक्षा कार्यक्रम</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>🌐 हमसे जुड़ें</h4>
            <div className="social-links">
              <a
                href="https://www.instagram.com/vision4thenature?igsh=YzljYTk1ODg3Zg=="
                target="_blank"
                rel="noopener noreferrer"
                className="social-link instagram"
              >
                📷 Vision for the Nature
              </a>
              <a
                href="https://youtube.com/@vision4nature?si=WE_9QmmFnzZc2MFq"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link youtube"
              >
                📺 @vision4nature
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100092514897253"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link facebook"
              >
                👥 Vision4Nature Page
              </a>
              <a
                href="https://whatsapp.com/channel/0029VaD03EqBVJl7L2sBAi3v"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link whatsapp"
              >
                💬 WhatsApp Channel
              </a>
              <a
                href="https://x.com/vision4thenatur?t=He6f5b3ezwxZRsEbdyBnkQ&s=09"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link twitter"
              >
                🐦 @vision4thenatur
              </a>
            </div>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>&copy; 2024 Vision. सभी अधिकार सुरक्षित।</p>
            </div>
            <div className="mission-statement">
              <p>
                <strong>🌱 स्वच्छ कटनी, स्वस्थ कटनी - Vision के साथ</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
